module.exports = __webpack_public_path__ + "assets/img/logo-hpcr.35ee3926.svg";